export default function () {
  return function (obj) {
    return _.reduce(obj, function (acc, errors, key) {
      acc = acc.concat(errors);
      return acc;
    }, []).join('. ') + '.';
  };
}
